import * as React from "react";
import { Option, useFormApi, useFormState } from "informed";
import { ConfigFieldDropdown } from "../../forms/informedv2/ConfigFieldDropdown";
import { TextBox } from "../../forms/informedv2/TextBox";
import { TimePicker } from "../../forms/informedv2/TimePicker";
import { Required } from "../../forms/validation/Required";
import { SubjectAlarms } from "./SubjectAlarms";
import { Site } from "webportalclient";
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { Language } from "../../misc/api/apiTypes";
import { SubjectFormModel } from "../SubjectsShared";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";

interface SubjectEdiaryFormBodyProps {
    sites: Site[];
    enabled: boolean;
    onSetLimitedLanguages: React.Dispatch<React.SetStateAction<Language[]>>
    subjectLimitedLanguages: Language[];
}

export const SubjectEdiaryFormBody = ({ sites, enabled, onSetLimitedLanguages, subjectLimitedLanguages }: SubjectEdiaryFormBodyProps) => {
    const { languages, studySubjectSetting } = useCurrentStudyConfigurationContext();
    const formApi = useFormApi<SubjectFormModel>();
    const formState = useFormState<SubjectFormModel>();

    React.useEffect(() => {
        if (!enabled)
            return;

        const site = sites.find(s => s.id === formState.values.SiteId);
        if (site) {
            if (studySubjectSetting?.limitSubjectLanguageSelectionToSiteCountry) {
                onSetLimitedLanguages(languages.filter(x => x.Id.endsWith(site.country)))
                if (subjectLimitedLanguages.length != 0 && !subjectLimitedLanguages.some(x => x.Id == formState.values.LanguageId))
                    formApi.setValue('LanguageId', undefined);
            } else {
                onSetLimitedLanguages(languages);
            }
        } else {
            if (studySubjectSetting?.limitSubjectLanguageSelectionToSiteCountry) {
                onSetLimitedLanguages([])
            } else {
                onSetLimitedLanguages(languages);
            }
        }
    }, [enabled, sites, formState.values.SiteId]);

    if (!enabled) return null;

    return (
        <>
            <div className="row">
                <div className="form-group col-sm-4 col-xs-12">
                    <label htmlFor="Pin">PIN</label>
                    <TextBox id="Pin" field="Pin" required={true} placeholder="####" type="password" validate={Required} autoComplete="new-password" />
                </div>

                <div className="form-group col-sm-4 col-xs-12">
                    <label htmlFor="PinConfirmation">PIN Confirmation</label>
                    <TextBox id="PinConfirmation" field="PinConfirmation" required={true} placeholder="####" type="password" validate={Required} autoComplete="new-password" />
                </div>
                <div className="form-group col-sm-4 col-xs-12">
                    <TimePicker
                        id="BedTime"
                        field="BedTime"
                        label="Bed Time"
                        placeholderText="HH:mm (24 hour format)"
                        required={false}
                        dateFormat="HH:mm"
                    />
                </div>
            </div>
            <div className="row">
                <ConfigFieldDropdown
                    id="Language"
                    field="LanguageId"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    required={true}
                    itemId={ConfigurableDataItemIds.SubjectLanguage}
                >
                    {
                        subjectLimitedLanguages.map(so => (
                            <Option
                                key={`Option${so.Id}`}
                                value={so.Id}
                            >
                                {so.Name}
                            </Option>
                        ))}
                </ConfigFieldDropdown>
            </div>

            <SubjectAlarms />

        </>
    );
}
